export * from './Tab/types';
export * from './ScrollableTabs/types';
export * from './TabsNavButton/types';
export var TabsSkin;
(function (TabsSkin) {
    TabsSkin["fullUnderline"] = "fullUnderline";
    TabsSkin["clear"] = "clear";
    TabsSkin["fitUnderline"] = "fitUnderline";
})(TabsSkin || (TabsSkin = {}));
export var TabsAlignment;
(function (TabsAlignment) {
    TabsAlignment["center"] = "center";
    TabsAlignment["left"] = "left";
    TabsAlignment["right"] = "right";
})(TabsAlignment || (TabsAlignment = {}));
export var TabsVariant;
(function (TabsVariant) {
    TabsVariant["fullWidth"] = "fullWidth";
    TabsVariant["fit"] = "fit";
})(TabsVariant || (TabsVariant = {}));
//# sourceMappingURL=types.js.map